export default "__VITE_ASSET__e05b53ea__"